export const messages = {
  en: {
    newOaWorkflowManage: {
      noPublishedFlow: 'You have not published any workflows, please publish them in the workflow instances first',
      flowNotDeployed: 'Workflow is not deployed'
    }
  },
  zh: {
    newOaWorkflowManage: {
      noPublishedFlow: '您还没有发布流程，请先到流程实例中发布流程',
      flowNotDeployed: '流程未部署'
    }
  }
}